var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoParaMi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9381 14.3212C45.0742 13.6315 44.9807 12.9163 44.6719 12.2848C44.3631 11.6533 43.856 11.1403 43.2281 10.8243L25.4344 1.92741C24.9885 1.70634 24.4976 1.59131 24 1.59131C23.5023 1.59131 23.0114 1.70634 22.5656 1.92741L4.77186 10.8243C4.14397 11.1403 3.63687 11.6533 3.32807 12.2848C3.01927 12.9163 2.92576 13.6315 3.06186 14.3212L5.55373 26.7768C6.57803 31.9029 9.47851 36.4623 13.6875 39.5624L14.4581 40.1249C14.5044 38.9927 14.687 37.8703 15.0019 36.7818C11.6439 34.1324 9.33989 30.3733 8.5031 26.1787L5.99998 13.7324C5.99177 13.688 5.9981 13.6421 6.01803 13.6016C6.03796 13.5611 6.07043 13.528 6.11061 13.5074L23.9044 4.61054C23.9336 4.59642 23.9656 4.58909 23.9981 4.58909C24.0306 4.58909 24.0626 4.59642 24.0919 4.61054L41.8856 13.4999C41.9258 13.5205 41.9583 13.5536 41.9782 13.5941C41.9981 13.6346 42.0044 13.6805 41.9962 13.7249L39.5044 26.1824C39.2104 27.6474 38.7355 29.0702 38.0906 30.418C38.8844 31.1578 39.5897 31.9871 40.1925 32.8893C41.2565 30.9789 42.0157 28.914 42.4425 26.7693L44.9381 14.3212Z",
    fill: "url(#paint0_linear_12_155976)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2994 30.2025L31.3687 28.5844C32.3166 28.0684 33.1078 27.3063 33.6588 26.3784C34.2099 25.4504 34.5005 24.3911 34.5 23.3119V20.9381C34.5 19.3468 33.8679 17.8207 32.7426 16.6955C31.6174 15.5703 30.0913 14.9381 28.5 14.9381C26.9087 14.9381 25.3826 15.5703 24.2574 16.6955C23.1321 17.8207 22.5 19.3468 22.5 20.9381V23.3119C22.4995 24.3911 22.7901 25.4504 23.3412 26.3784C23.8922 27.3063 24.6834 28.0684 25.6313 28.5844L22.7006 30.2025C20.8231 31.2389 19.2577 32.7596 18.1672 34.6062C17.0767 36.4528 16.501 38.5579 16.5 40.7025V43.5C16.5 43.8978 16.658 44.2793 16.9393 44.5606C17.2206 44.842 17.6022 45 18 45H39C39.3978 45 39.7794 44.842 40.0607 44.5606C40.342 44.2793 40.5 43.8978 40.5 43.5V40.7081C40.5 38.5626 39.9248 36.4563 38.8342 34.6086C37.7437 32.7609 36.1777 31.2394 34.2994 30.2025Z",
    fill: "url(#paint1_linear_12_155976)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_155976",
    x1: 3.00098,
    y1: 1.59131,
    x2: 22.4619,
    y2: 49.3151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272135,
    stopColor: "#34263B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658079,
    stopColor: "#13172C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_155976",
    x1: 17.1279,
    y1: 17.2974,
    x2: 41.2816,
    y2: 36.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7052D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CA5AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoParaMi);
export default __webpack_public_path__ + "static/media/ico-para-mi.0e23ab16e35d053e6b2e4ece7b4664f8.svg";
export { ForwardRef as ReactComponent };